import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M8.6 4H3L9.60869 12.8116L3.35996 19.9999H5.47998L10.5906 14.1208L15 20H20.6L13.7134 10.8178L19.6401 4H17.5201L12.7314 9.50862L8.6 4ZM15.8 18.4L6.2 5.6H7.8L17.4 18.4H15.8Z"
        })
    }));
};
export default Icon;
